import { render, staticRenderFns } from "./C-3e-1__ProductList_Dialog-with-DropZone.vue?vue&type=template&id=3b51c4b9&"
import script from "./C-3e-1__ProductList_Dialog-with-DropZone.vue?vue&type=script&lang=js&"
export * from "./C-3e-1__ProductList_Dialog-with-DropZone.vue?vue&type=script&lang=js&"
import style0 from "./C-3e-1__ProductList_Dialog-with-DropZone.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports